<template>
    <div class="Incubator">
        <div class="product_number">产品编号：XXXXXXXXX</div>
        <div class="and_pictures">分类与图片</div>
        <setUp />
        <!-- 产品图片 -->
        <uploadPictures />
        <div class="and_pictures">公用信息</div>

        <!-- 基本信息 -->
        <Essentialinformation />

        <!-- 产品信息 -->
        <productInformation ref="productInformation" />

        <!-- 变体信息 -->
        <Variantinformation />
        <div class="EstablishProduct_bottom">
            <span>保存至待同步</span>
            <span>保存并上传</span>
        </div>
    </div>
</template>

<script>
import setUp from "./EstablishProductClassificationModular/setUp";
import cropper from "./elasticFrame/cropper";
import uploadPictures from "./EstablishProductClassificationModular/uploadPictures";
import productInformation from "./EstablishProductClassificationModular/productInformation";
import Variantinformation from "./EstablishProductClassificationModular/Variant_information";
import Essentialinformation from "./EstablishProductClassificationModular/essential_information";
export default {
    name: "EstablishProduct",
    components: {
        cropper,
        uploadPictures,
        productInformation,
        Variantinformation,
        Essentialinformation,
        setUp
    },
    data() {
        return {};
    },
    mounted() {
        this.$refs.productInformation.Incubator();
    },
    created() {},
    methods: {}
};
</script>

<style lang="scss">
.Incubator {
    width: 98%;
    margin: auto;
    .product_number {
        line-height: 30px;
    }
    .and_pictures {
        line-height: 30px;
        border-bottom: #8d8e8f 1px solid;
    }
    .Ministerborder {
        padding: 0 0 3px 0;
        border: 1px solid #cce198;
        margin-top: 1%;
    }
    .informationborder {
        border: 1px solid #7ecef4;
    }
    .productborder {
        border: 1px solid #f19ec2;
    }
    .information {
        border: 1px solid #f19ec2;
        margin-top: 1%;
    }
    .Minister-top {
        width: 99%;
        border-radius: 4px;
        .Minister-top-top {
            width: 100%;
            height: 40px;
            .Minister-top-left {
                width: 80px;
                line-height: 40px;
                float: left;
                text-align: center;
                font-size: 16px;
            }
            .Minister-top-color {
                color: #567801;
            }
            .product-top-color {
                color: #c80f5f;
            }
            .information-top-color {
                color: #026695;
            }
            .Minister-top-right {
                width: 80px;
                line-height: 40px;
                float: right;
                font-size: 16px;
                text-align: center;
            }
        }
        .Ministerbackground {
            background: #cce198;
        }
        .productbackground {
            background: #f19ec2;
        }
        .informationbackground {
            background: #7ecef4;
        }
        .productimgs {
            padding: 10px;
        }
        .classification {
            margin-left: 50px;
            margin-top: 10px;
            padding: 0 0 20px 0;
            overflow: hidden;
            .classification_left {
                width: 55%;
                overflow: hidden;
                float: left;
                .classification_content {
                    overflow: hidden;
                    .station_left {
                        width: 13%;
                        line-height: 40px;
                        float: left;
                    }
                    .station_left:before {
                        content: "*";
                        line-height: 40px;
                        float: left;
                        width: 11%;
                    }
                    .station_right {
                        float: right;
                        width: 86%;
                        div {
                            width: 100%;
                            color: #c19898;
                            line-height: 40px;
                        }
                    }
                }
            }
            .classification_right {
                width: 25%;
                padding: 5px 10px 5px 0;
                margin-top: 25px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
                float: left;
                .elasticFrame {
                    padding: 10px 0;
                    width: 100%;
                    .elasticFrame_classification {
                        width: 20%;
                        text-align: right;
                        float: left;
                        line-height: 30px;
                        margin-right: 2%;
                    }
                    .el-input {
                        width: 72%;
                    }
                    .el-button--primary {
                        margin-left: 22%;
                    }
                }
                .Preservation {
                    float: right;
                    padding: 5px 10px;
                    background: #73ade9;
                    color: #fff;
                    margin-top: 5px;
                    border-radius: 5px;
                }
            }
        }
        .information_content {
            width: 96%;
            margin: auto;
            overflow: hidden;
            padding: 10px 0;
            .titlelist {
                width: 85%;
                margin-left: 6%;
                border: 1px solid #eee;
                .el-table .cell,
                .el-table th div {
                    padding-left: 5px;
                    padding-right: 0;
                }
            }
            .information_Mandarin {
                overflow: hidden;
                margin-left: 4%;
                height: 45px;
                ul {
                    width: 70%;
                    float: left;
                    li {
                        width: 10%;
                        line-height: 35px;
                        text-align: center;
                        float: left;
                    }
                    .liactive {
                        background: #2c8dff;
                        color: #fff;
                    }
                }
                .translate {
                    float: right;
                    span {
                        background: #73ade9;
                        color: #fff;
                        line-height: 35px;
                        border-radius: 5px;
                        padding: 5px 10px;
                        margin-left: 5px;
                    }
                }
            }
            .information_tips {
                line-height: 50px;
                margin-left: 6%;
                color: #f89a9a;
                font-size: 16px;
            }
            .information_input {
                overflow: hidden;
                .information_Title {
                    width: 5%;
                    overflow: hidden;
                    color: #7d7171;
                    text-align: left;
                    float: left;
                    line-height: 40px;
                }
                .input_el {
                    width: 94%;
                    float: left;
                    .width85 {
                        width: 85%;
                    }
                    .width97 {
                        width: 93%;
                    }
                    .el-input {
                        padding: 3px 0;
                    }
                    .Preservation {
                        float: right;
                        padding: 10px 10px;
                        background: #73ade9;
                        color: #fff;
                        margin-top: 5px;
                        border-radius: 5px;
                    }
                }
                .input_span {
                    .el-input__count {
                        bottom: 19px;
                    }
                }
            }
        }
        .product_information_content {
            width: 97%;
            margin: 1% auto;
            .product_information {
                overflow: hidden;
                float: left;
                width: 23%;
                padding: 10px 0;
                margin-right: 2%;
                .el-select {
                    width: 96px;
                }
            }
            .address {
                width: 80%;
                padding: 10px 0;
            }
            .address_remarks {
                padding: 10px 0;
            }
            .price {
                padding: 15px 0;
            }
            .product_bottom {
                overflow: hidden;
                padding: 10px 0;
                .product_left {
                    width: 20%;
                    float: left;
                    span {
                        display: block;
                        float: left;
                        line-height: 40px;
                    }
                }
                .product_in {
                    width: 26%;
                    line-height: 40px;
                    float: left;
                    .el-input {
                        width: 80%;
                    }
                }
                .product_right {
                    float: left;
                    width: 20%;
                    margin-left: 2%;
                }
                .setright {
                    margin-right: 2%;
                }
            }
        }
        .variant {
            width: 97%;
            margin: auto;
            .variant_top {
                width: 100%;
                margin-top: 20px;
            }
            .variant_content {
                margin: 30px 0 20px 0;
                border: 1px solid #eee;
                .cell {
                    span:nth-child(2) {
                        color: #409eff;
                    }
                }
            }
        }
    }
    .EstablishProduct_bottom {
        float: right;
        margin-top: 40px;
        margin-bottom: 40px;
        span {
            padding: 5px 10px;
            color: #fff;
            border-radius: 5px;
        }
        span:nth-child(1) {
            background: #67c23a;
            margin-right: 10px;
        }
        span:nth-child(2) {
            background: #409eff;
        }
    }
    .uploaderImg .el-upload__text {
        width: 100%;
        height: 28px;
        text-align: center;
    }
    .rs-tab {
        width: 853px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        margin-top: 10px;
        padding: 10px 0;
        line-height: 25px;
    }
    .rs-tab li {
        display: inline-block;
    }
}
</style>